import { CardShell } from "@/shared/ui/CardShell";
import { CardMenu } from "@/shared/ui/CardMenu";
import { PaymentMethodsClient } from "./PaymentMethodsClient";

export function PaymentMethods() {
  return <PaymentMethodsClient />;
}
